// @ts-nocheck
// Multi-tenant feature flags
// TODO: load from company_settings DB per tenant
// Tailwind (company_id=1): customizations below
export const SHOW_PER_PAGE_SIGNATURES = false;
export const SHOW_PER_PAGE_CHARTER_INFO = false; // future: restore charter#/vessel/customer/date headers
export const ENABLE_ROUTINE_CHECK = true;
